import { useState, useEffect, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SimpleGrid, FormLabel } from "@chakra-ui/react";
import Loading from "../../../Component/Loading/loading";
import apiService from "../../../Method/Report/Report_Service";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../../assets/Table/TableTheme";
import { t } from "i18next";
import { useDataContext } from "./../../../DataProvider";
import TableWidget from "../../../Component/Table/TableWidget";

const buildColumns = () => [

  {
    name: "USER_NAME",
    label: t("Employee"),
    options: {
      filter: false, sort: false,

      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("Employee")}</th>
      ),
    },
  },
  {
    name: "BILL_NUMBER",
    label: t("Invoice_No"),
    options: {
      filter: false, sort: false,

      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("Invoice_No")}</th>
      ),
    },
  },
  {
    name: "JOB_DATE",
    label: t("JOB_DATE"),
    options: {
      filter: false, sort: false,
      customBodyRender: (value) => {
        if (!value) return "";
        return value.split("T")[0];

      },
      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("JOB_DATE")}</th>
      ),

    },
  },

  {
    name: "D_TIME",
    label: t("Time"),
    options: {

      filter: false, sort: false,
      customBodyRender: (value) => {
        if (!value) return "";
        return value.split("T")[1].substring(0, 8);

      },
      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("Time")}</th>
      ),
    },
  },

  {
    name: "NOTE",
    label: t("NOTE"),
    options: {
      filter: false,
      sort: false,

      customHeadRender: (columnMeta) => {
        return (
          <th
            key={columnMeta.index}
            style={{
              minWidth: "800px",
              background: "var(--Table-Header-bg-color)",
              color: "var(--Table-Header-text-color)",

              padding: "9px", fontSize: "16px",
              fontWeight: "500", textAlign: "center"

            }}
          >
            {t("NOTE")}
          </th>
        );
      },



      customBodyRender: (value) => (
        <div
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {value}
        </div>
      )
    }
  },

  {
    name: "BILL_BRANCH",
    label: t("Order_No"),


    options: {
      filter: false, sort: false,

      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("Order_No")}</th>
      ),
    },

  },

  {
    name: "PROCCESS_TYPE",
    label: t("OPERATION"),
    options: {
      filter: false, sort: false,

      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("OPERATION")}</th>
      ),
    },

  },
  {
    name: "SCREEN_NAME",
    label: t("Screen"),
    options: {
      filter: false, sort: false,

      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("Screen")}</th>
      ),
    },
  },
  {
    name: "AMO",
    label: t("TOTAL_AMO"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },

      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("TOTAL_AMO")}</th>
      ),
    },

  },

  {
    name: "BRANCH_NAME",
    label: t("Branch_Name"),
    options: {
      filter: false, sort: false,

      customHeadRender: (columnMeta) => (
        <th key={columnMeta.index} style={{
          background: "var(--Table-Header-bg-color)",
          color: "var(--Table-Header-text-color)",
          padding: "9px", fontSize: "16px",
          fontWeight: "500", textAlign: "center"
        }}>{t("Branch_Name")}</th>
      ),
    },
  },


];

function App() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [totalAmo, setTotalAmo] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { trigger } = useDataContext();
  const [searchText, setSearchText] = useState("");



  const columns = useMemo(() => buildColumns(t), [t]);
  const [searchColumns, setSearchColumns] = useState(() =>
    columns.filter((c) => c.options?.search !== false).map((c) => c.name)
  );
  useEffect(() => {
    setSearchColumns(columns.filter((c) => c.options?.search !== false).map((c) => c.name));
  }, [columns]);

  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      const { success, data, error } = await apiService.search("GET_USER_DETAILS_ALL_REPORTS", page + 1, rowsPerPage);

      if (success && data) {
        setData(data.USER_DETAILS || []);
        setTotalCount(data.TOTAL_COUNT || 0);
        setTotalAmo(data.ALL_TOTAL_AMO || 0);
        setError("");
      } else {
        setError(error?.response?.data?.message || "خطأ في التحميل");
      }
    } catch (err) {
      setError(err.message || "خطأ");
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchData();
  }, [trigger, fetchData]);
  const filteredData = (data || []).filter((row) => {
    const q = (searchText || "").toLowerCase().trim();
    if (!q) return true;
    return searchColumns.some((name) =>
      row?.[name]?.toString().toLowerCase().includes(q)
    );
  });
  return (
    <ThemeProvider theme={theme}>
      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      <div>
        {!isLoading && (
          <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }} className="Total_Header_Without_Bg">
            <SimpleGrid className="Total_Header" columns={{ base: 1, md: 2 }}>
              <div>
                <FormLabel className="Total_Header_Right">{t("TOTAL_OPERATIONS")}</FormLabel>
                <FormLabel className="Total_Header_Value">{(totalCount || 0).toLocaleString()}</FormLabel>
              </div>
              <div>
                <FormLabel className="Total_Header_Left">{t("TOTAL_AMO_ALL")}</FormLabel>
                <FormLabel className="Total_Header_Value">{(totalAmo || 0).toLocaleString()}</FormLabel>
              </div>
            </SimpleGrid>
            <TableWidget
              title={t("Monitor_Screen_Report")}
              data={filteredData}
              onSearchChange={setSearchText}
              columns={columns}
              totalCount={totalCount}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
              searchColumns={searchColumns}
              setSearchColumns={setSearchColumns}
            />

          </div>
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
